import React, { useState, useRef, useEffect } from 'react'
import styles from '../../../styles/LandingPagev1/action-button.module.css'

export default function ActionButton({ title = "Get started with Vin", styleContainer = "container", handleBtnClick, icon, direction = 'top' }) {
    const buttonRef = useRef(null);
    return (
        <React.Fragment>
            <div
                ref={buttonRef}
                className={styles[styleContainer]}
                onClick={(e) => {
                    e.stopPropagation()
                    handleBtnClick && handleBtnClick(buttonRef?.current, title, null, direction);
                }}
            >
                <div className={styles.titleiconstyles}>
                {icon && <img src={icon} alt="icon" className={styles.buttonIcon} />}
                <div className={styles.title}>{title}</div>
                </div>
            </div>
        </React.Fragment>
    )
}
